import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import html2canvas from 'html2canvas';
import { Observable, Subscription, firstValueFrom, take, timeout } from 'rxjs';
import { AuthUserService } from 'src/app/core/services/auth-user.service';
import { ToastrShowService } from 'src/app/core/services/toastr.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { REPORT } from 'src/app/core/constants/report.constants';
import { LoaderService } from 'src/app/core/services/loader.service';
import {
  CapitalGainData,
  DetailReport
} from 'src/app/core/models/broker-admin';
import * as XLSX from 'xlsx';
import {
  ClientReportResponse,
  ClientResponse,
  PortfolioMetric,
  SoaDownload,
  TransactionResponse
} from '../../../../core/models/transaction.model';
import dayjs from 'dayjs';
import { SharedModuleService } from 'src/app/core/services/shared-module.service';
import { NumberFormattingService } from 'src/app/core';
@Injectable({
  providedIn: 'root'
})
export class ReportsModuleService {
  reportData = { type: '', name: '' };
  cardIndex = 0;
  userId!: string;
  transactionData!: TransactionResponse;
  portfolioSummaryData: any;
  portfolioDetailData:
    DetailReport[] | { detailPortfolioReport: DetailReport[] } | null = null;
  portfolioSummaryDate: any;
  portfolioDetailDate: any;
  nseValue: any;
  clientList!: ClientResponse;
  clientandRMDetails: any;
  transactionStartDate: any;
  transactionEndDate: any;
  capitalGainData: CapitalGainData[] | null = null;
  clientUserId: any;
  document!: any;
  todayDate!: Date;
  logoData: any;
  // Angular 19: Use inject() for DI
  private userDetailsSub?: Subscription;
  private http = inject(HttpClient);
  private authUser = inject(AuthUserService);
  private loaderService = inject(LoaderService);
  private toastr = inject(ToastrShowService);
  private logger = inject(LoggerService);
  private sharedModuleService = inject(SharedModuleService);
  private numberFormattingService = inject(NumberFormattingService);

  transactionReport(
    userId: string,
    clientId: string,
    viewMode: string,
    reportCreationDate: string,
    reportEndDate: string
  ): Observable<any> {
    const obj = {
      brokerId: userId,
      clientId: clientId,
      viewMode: viewMode,
      // "dataSource": dataSource,
      reportCreationDate: reportCreationDate,
      reportEndDate: reportEndDate
    };
    return this.http.post('transactionReport', obj);
  }
  /**
   * Created to get the logged in user details
   */
  getUserDetails() {
    // Root service: drop any previous subscription so repeated calls don't stack listeners.
    this.userDetailsSub?.unsubscribe();
    this.userDetailsSub = this.authUser
      .getUserDetailBehaviorSubject()
      .subscribe((data) => {
        if (data) {
          this.userId = data.userId;
        }
        this.getClientsList();
      });
  }

  /**
   * To get the details of clients for logged in user
   */
  getClientsList() {
    const obj = {
      userIdOfClient: '',
      userId: this.userId
    };
    return this.http.post<ClientResponse>('get/listOfClients', obj);
  }
  /**
   * To get the details of clients for logged in user
   * @param userId - User ID (RM or Broker/Advisor)
   * @param roleId - Role ID of the user
   * @param clientUserId - Optional client user ID (for CLIENT role to get their own data)
   */
  clientName(
    userId: string,
    roleId: number,
    clientUserId?: string
  ): Observable<any> {
    const obj = {
      userId: userId,
      clientUserId: clientUserId || '',
      roleId: roleId
    };
    return this.http.post<ClientReportResponse>('clients-list', obj);
  }
  /**
   *  Creates for the summary portfolio report
   * @param payload
   * @returns
   */
  // portfolioSummaryReport(payload: {
  //   pan?: string;
  //   arn?: string;
  //   endDate?: string;
  // }) {
  //   return this.http.post<TransactionResponse>(
  //     'portfolio/valuation/ui',
  //     payload
  //   );
  // }
  // NEW API endpoint
  portfolioSummaryValuation(payload: {
    pan?: string;
    arn?: string;
    endDate?: string;
  }) {
    return this.http.post<any>('portfolio/valuation', payload);
  }
  portfolioSummarySectorwise(payload: {
    pan?: string;
    arn?: string;
    endDate?: string;
  }) {
    return this.http.post<any>('portfolio/sector-allocation', payload);
  }
  portfolioSummaryValuationMf(payload: {
    pan?: string;
    arn?: string;
    endDate?: string;
  }) {
    return this.http.post<any>('v2/portfolio/asset-allocation', payload);
  }
  /**
   *  Creates for the portfolio metrics graph
   * @param payload
   * @returns
   */
  portfolioMetricsGraph(payload: {
    pan?: string;
    arn?: string;
    endDate?: string;
    startDate?: string;
  }) {
    return this.http.post<PortfolioMetric>('portfolio/metrics', payload);
  }
  setPortfolioSummaryReportDate(date: string) {
    this.portfolioSummaryDate = date;
  }
  getPortfolioSummaryReportDate() {
    return this.portfolioSummaryDate;
  }

  getNSEvalue() {
    return this.http.get<any>('get/accordNSEPrice');
  }

  getClientandRMDetails(clientId?: string) {
    const obj = {
      userId: clientId
    };
    return this.http.post<any>('details/rm-and-client', obj);
  }

  portfolioDetailReport(payload: {
    pan?: string;
    arn?: string;
    endDate?: string;
  }): Observable<DetailReport[]> {
    return this.http.post<DetailReport[]>(
      'portfolio/valuation/detailed',
      payload
    );
  }
  /**
   * Creates for the summary transaction report
   * @param payload
   * @returns
   */
  transactionSummaryReport(payload: {
    arn?: string;
    pan?: string;
    startDate?: string;
    endDate?: string;
  }): Observable<TransactionResponse> {
    return this.http.post<TransactionResponse>(
      'transaction/history/ui',
      payload
    );
  }

  /**
   * Creates for the capital gain realized both summary and detailed report
   * @param payload
   * @returns
   */

  capitalGainReport(payload: {
    pan?: string;
    arn?: string;
    startDate?: string;
    endDate?: string;
  }): Observable<CapitalGainData[]> {
    return this.http.post<CapitalGainData[]>('capital/gain', payload);
  }

  /**
   * Creates for the capital gain unrealized both summary and detailed report
   * @param payload
   * @returns
   */
  capitalGainUnrealizedReport(payload: {
    pan?: string;
    arn?: string;
    startDate?: string;
    endDate?: string;
  }): Observable<CapitalGainData[]> {
    return this.http.post<CapitalGainData[]>(
      'capital/gain/unrealised',
      payload
    );
  }

  mailReport(formData: any): Observable<any> {
    this.document = null;
    return this.http.post<any>('email/report-pdf', formData).pipe(
      timeout(60000) // 60 second timeout for email sending
    );
  }
  /**
   * function to get soa data
   * @method soaReportData
   * @memberof reportService
   */
  soaReportData(
    id: string,
    organizationId: string,
    clientValu: ClientReportResponse
  ): Observable<SoaDownload[]> {
    const dataSoa = {
      brokerAdminUserId: id,
      organizationId: organizationId,
      clientDetails: clientValu
    };
    return this.http.post<SoaDownload[]>('soa/url', dataSoa);
  }

  /**
   * For pdf generates - now accepts base64 strings instead of canvas elements
   * @method pdfmakegenerator
   * @memberof reportService
   */
  async pdfmakegenerator(
    dataSource: any,
    dateReport: any,
    NSE: any,
    BSE: any,
    clientRm: any,
    columnDataDisplay: any,
    reportName: string,
    obj: any,
    mailReport: boolean,
    chartBase64_1?: string | null,
    chartBase64_2?: string | null,
    chartBase64_3?: string | null
  ) {
    const NSEvalue = NSE;
    const BSEvalue = BSE;
    const date = dateReport;
    const detailsRMClient = clientRm;
    const data = dataSource;
    const column = columnDataDisplay;
    this.generatePdfWithLogoAndDescription(
      date,
      NSEvalue,
      BSEvalue,
      detailsRMClient,
      data,
      column,
      reportName,
      obj,
      mailReport,
      chartBase64_1,
      chartBase64_2,
      chartBase64_3
    );
  }

  ensureDataUrl(base64Str: string, mimeType = 'image/png'): string {
    if (!base64Str.startsWith('data:image')) {
      return `data:${mimeType};base64,${base64Str}`;
    }
    return base64Str;
  }

  private convertSvgToPng(
    svgDataUrl: string,
    width = 300,
    height = 120
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Could not get canvas 2d context'));
          return;
        }
        ctx.drawImage(img, 0, 0, width, height / 1.2);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = svgDataUrl;
    });
  }

  /**
   * function to generate image as base 64
   * @method getBase64ImageFromURL
   * @memberof reportService
   */
  async getBase64ImageFromURL(url: string) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result as string));
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  }

  /**
   * function to generate pdf and image - now uses base64 strings
   * @method generatePdfWithLogoAndDescription
   * @memberof reportService
   */
  async generatePdfWithLogoAndDescription(
    date: string,
    NSEvalue: string,
    BSEvalue: string,
    detailsRMClient: any,
    data: any[],
    column: any,
    reportName: string,
    obj: any,
    mailReport: boolean,
    chartBase64_1: string | null | undefined,
    chartBase64_2: string | null | undefined,
    chartBase64_3: string | null | undefined
  ): Promise<void> {
    this.loaderService.show();
    try {
      const svgDataUrl: string = await this.getBase64ImageFromURL(
        'assets/images/gemfin-logo.svg'
      );
      // pdfmake only supports PNG/JPEG — convert SVG default logo to PNG
      const defaultLogo: string = await this.convertSvgToPng(svgDataUrl).catch(
        () => svgDataUrl
      );

      // Get logo data asynchronously
      const logoDataResponse = await new Promise<any>((resolve) => {
        this.sharedModuleService
          .getLogoData()
          .pipe(take(1))
          .subscribe(
            (data) => resolve(data || { base64Image: defaultLogo }),
            () => resolve({ base64Image: defaultLogo })
          );
      });
      this.logoData = logoDataResponse;

      // Load pdfMake dynamically with proper font configuration
      const pdfMake = await this.loadPdfMake();

      // Create document definition (header part of the PDF)
      const documentDefinition: any = {
        pageOrientation: 'landscape',
        pageSize: 'A4',
        content: [
          {
            columns: [
              {
                width: '33%',
                stack: [
                  {
                    text: 'Client Details:',
                    style: 'content',
                    bold: true,
                    decoration: 'underline',
                    margin: [0, 0, 0, 3]
                  },

                  {
                    text: [
                      {
                        text:
                          this.safeText(detailsRMClient?.clientName) || 'N/A',
                        style: 'content',
                        bold: true
                      },
                      { text: ' | ', style: 'content', bold: false },
                      {
                        text:
                          this.safeText(detailsRMClient?.clientPan) || 'N/A',
                        style: 'content',
                        bold: false
                      }
                    ],
                    margin: [0, 0, 0, 2]
                  },

                  {
                    text: this.safeText(detailsRMClient?.clientPhone) || 'N/A',
                    style: 'content',
                    margin: [0, 0, 0, 2]
                  },

                  {
                    text: this.safeText(detailsRMClient?.clientEmail) || 'N/A',
                    style: 'content',
                    link: `mailto:${this.safeText(detailsRMClient?.clientEmail)}`,
                    margin: [0, 0, 0, 2]
                  },
                  {
                    text:
                      this.safeText(detailsRMClient?.clientAddress) || 'N/A',
                    style: 'content',
                    // margin: [0, 10],
                    lineBreak: true,
                    noWrap: false
                  }
                ]
              },
              {
                width: '34%',
                stack: [
                  // {
                  //   image: companyLogoUrl,
                  //   fit: [593, 513] as [number, number],
                  //   alignment: 'center',
                  //     absolutePosition: { x: 0, y: 0 }
                  //  },
                  {
                    image: this.ensureDataUrl(
                      this.logoData?.base64Image || defaultLogo
                    ),
                    fit: [150, 60],
                    alignment: 'center',
                    margin: [0, 0, 0, 5]
                    // margin: [0, 10]
                  },
                  {
                    text: this.safeText(reportName) || 'Portfolio Report',
                    style: 'reportTitle',
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                    color: '#215099'
                  },
                  {
                    text: [
                      { text: 'Since Inception till ', style: 'date' },
                      {
                        text: this.safeText(date) || 'N/A',
                        style: 'date',
                        bold: true
                      }
                    ],
                    alignment: 'center'
                    // margin: [0, 10],
                  }
                ]
              },
              {
                width: '33%',
                stack: [
                  {
                    text: 'Relationship Manager:',
                    style: 'content',
                    bold: true,
                    decoration: 'underline',
                    margin: [0, 0, 0, 3]
                  },

                  {
                    text: this.safeText(detailsRMClient?.rmName) || 'N/A',
                    style: 'content',
                    bold: true,
                    margin: [0, 0, 0, 2]
                  },

                  {
                    text: this.safeText(detailsRMClient?.rmPhone) || 'N/A',
                    style: 'content',
                    margin: [0, 0, 0, 2]
                  },

                  {
                    text: this.safeText(detailsRMClient?.rmEmail) || 'N/A',
                    style: 'content',
                    link: `mailto:${this.safeText(detailsRMClient?.rmEmail)}`,
                    margin: [0, 0, 0, 2]
                  },
                  {
                    text: [
                      { text: 'BSE Sensex: ', style: 'content', bold: true },
                      {
                        text: this.safeText(BSEvalue) || 'N/A',
                        style: 'Value'
                      },
                      { text: '   |   ', style: 'content', bold: false },
                      { text: 'NSE Nifty: ', style: 'content', bold: true },
                      { text: this.safeText(NSEvalue) || 'N/A', style: 'Value' }
                    ],
                    alignment: 'right',
                    margin: [0, 10]
                  }
                ],
                alignment: 'right'
              }
            ]
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 760,
                y2: 0,
                lineWidth: 0.2
              }
            ],
            margin: [0, 5]
          }
        ],

        footer: (currentPage: number, pageCount: number) => ({
          margin: [40, 0],
          stack: [
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0,
                  y1: 0,
                  x2: 760,
                  y2: 0,
                  lineWidth: 0.2
                }
              ],
              margin: [0, 5, 0, 5]
            },
            {
              text: `Page ${currentPage} of ${pageCount}`,
              alignment: 'center',
              style: 'date'
            },
            { text: '', margin: [0, 10] }
          ]
        }),

        header: (currentPage: number) => {
          if (currentPage === 1) {
            return '';
          }
          return {
            margin: [40, 10],
            stack: [
              {
                columns: [
                  {
                    text: detailsRMClient?.clientName || '',
                    style: 'content',
                    width: '33%'
                  },
                  {
                    text: reportName || '',
                    style: 'content',
                    alignment: 'center',
                    width: '34%'
                  },
                  {
                    text: `As on ${date}`,
                    style: 'content',
                    alignment: 'right',
                    width: '33%'
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 0,
                    x2: 760,
                    y2: 0,
                    lineWidth: 0.2
                  }
                ]
              },
              { text: '', margin: [0, 10] }
            ]
          };
        },

        styles: this.getSafeStyles()
      };

      if (reportName === 'Portfolio Valuation Summary Report') {
        const contentBlocks: any[] = [];

        // Always add investment details first
        contentBlocks.push(...this.getInvestmentDetails(data));

        // Add charts if available (using base64 strings - no html2canvas)
        if (chartBase64_1 && chartBase64_2 && chartBase64_3) {
          contentBlocks.push(
            ...this.getChartDataFromBase64(
              chartBase64_1,
              chartBase64_2,
              chartBase64_3
            )
          );
        }

        // Add page break before tables
        contentBlocks.push({
          text: ''
        });

        // Add tables
        try {
          const tablesData = await this.getTablesSafely(data);
          contentBlocks.push(...tablesData);
        } catch (err) {
          this.logger.warn(
            'Table generation failed',
            'ReportsModuleService.generatePdfWithLogoAndDescription',
            err
          );
        }

        // These don't depend on canvas rendering
        contentBlocks.push(...this.getAllocationPercentage(data));
        contentBlocks.push(...this.getTopFiveFunds(data));

        documentDefinition.content.push(contentBlocks);
      } else {
        this.dynamiContent(data, documentDefinition, column, reportName);
      }

      // Add disclaimer
      // Add disclaimer as a regular content block at the end (no absolute positioning)
      documentDefinition.content.push({
        text: [
          { text: 'Disclaimer: ', bold: true, color: '#1A1A1A' },
          { text: REPORT.DISCLAIMER }
        ],
        style: 'disclaimer',
        margin: [20, 60, 20, 0] // Add top margin to separate from previous content
      });

      // Format names for file
      const sanitizedReportName = reportName.replace(/\s+/g, '_');
      const sanitizedClientName =
        detailsRMClient?.clientName?.replace(/\s+/g, '_') || 'Client';
      const todayDate = dayjs().format('YYYYMMDD');

      // Generate and process PDF
      if (!mailReport) {
        // Simple download
        await new Promise<void>((resolve, reject) => {
          try {
            pdfMake
              .createPdf(documentDefinition)
              .download(
                `${sanitizedReportName}_${sanitizedClientName}_${todayDate}.pdf`
              );
            setTimeout(() => {
              this.loaderService.hide();
              this.toastr.showSuccess(REPORT.PDF_DOWNLOAD);

              resolve();
            }, 1000);
          } catch (err) {
            this.logger.error(
              'PDF creation for download failed',
              'ReportsModuleService.generatePdfWithLogoAndDescription',
              err
            );
            reject(err);
          }
        });
      } else {
        // Mail the report
        const blob = await new Promise<Blob>((resolve, reject) => {
          try {
            pdfMake.createPdf(documentDefinition).getBlob((blob: Blob) => {
              resolve(blob);
            });
          } catch (err) {
            this.logger.error(
              'PDF blob creation failed',
              'ReportsModuleService.generatePdfWithLogoAndDescription',
              err
            );
            reject(err);
          }
        });

        const formdata = new FormData();
        formdata.append(
          'file',
          blob,
          `${sanitizedReportName}_${sanitizedClientName}_${todayDate}.pdf`
        );
        formdata.append('formDetails', JSON.stringify(obj));

        try {
          const res = await firstValueFrom(this.mailReport(formdata));
          const messageToShow = res.message;
          this.toastr.showSuccess(messageToShow);
        } catch (error: any) {
          this.logger.error(
            'Email sending failed',
            'ReportsModuleService.generatePdfWithLogoAndDescription',
            error
          );
          console.error(
            'Email error details:',
            error?.error?.message || error.message || error
          );
          this.toastr.showError('Failed to email report');
        } finally {
          // Hide loader after email operation completes (success or failure)

          this.loaderService.hide();
        }
      }
    } catch (error: any) {
      this.logger.error(
        'PDF generation failed',
        'ReportsModuleService.generatePdfWithLogoAndDescription',
        {
          error: error?.message || error,
          reportName,
          clientId: obj?.clientUserId,
          stack: error?.stack
        }
      );

      // Handle specific font errors
      if (
        error?.message?.includes('charCodeAt') ||
        error?.message?.includes('font')
      ) {
        this.toastr.showError(
          'Font loading error. Please try again or contact support.'
        );
      } else if (
        error?.message?.includes('canvas') ||
        error?.message?.includes('chart')
      ) {
        this.toastr.showError(
          'Chart rendering error. Please try switching to table view and retry.'
        );
      } else {
        this.toastr.showError('Failed to generate PDF. Please try again.');
      }

      // Hide loader on any PDF generation error
      this.loaderService.hide();
    }
  }

  // New helper methods for safe chart and table generation
  private async getChartDataSafely(
    ele1: any,
    ele2: any,
    ele3: any
  ): Promise<any[]> {
    try {
      if (!ele1 || !ele2 || !ele3) {
        throw new Error('One or more chart elements missing');
      }

      // Generate canvas with error handling
      const generateCanvas = async (element: any) => {
        if (!element) {
          return null;
        }
        try {
          return await html2canvas(element, { scale: 3 });
        } catch (err) {
          console.warn('Failed to render chart canvas', err);
          return null;
        }
      };

      // Generate all canvases with a timeout for safety
      const canvasPromises = [
        Promise.race([generateCanvas(ele1), this.timeoutPromise(3000)]),
        Promise.race([generateCanvas(ele2), this.timeoutPromise(3000)]),
        Promise.race([generateCanvas(ele3), this.timeoutPromise(3000)])
      ];

      const [canvas1, canvas2, canvas3] = await Promise.all(canvasPromises);

      // If any canvas failed to generate, throw error
      if (!canvas1 || !canvas2 || !canvas3) {
        throw new Error('Failed to render one or more charts');
      }

      // Create chart headers
      const chartHeaders = {
        // ... your existing chart headers ...
      };

      return [
        chartHeaders,
        {
          columns: [
            {
              image: canvas1.toDataURL('image/png'),
              fit: [250, 200],
              margin: [10, 0, 10, 15],
              width: '33.3%',
              alignment: 'center'
            },
            {
              image: canvas2.toDataURL('image/png'),
              fit: [250, 200],
              margin: [10, 0, 10, 15],
              width: '33.3%',
              alignment: 'center'
            },
            {
              image: canvas3.toDataURL('image/png'),
              fit: [250, 200],
              margin: [10, 0, 10, 15],
              width: '33.3%',
              alignment: 'center'
            }
          ],
          columnGap: 0
        }
      ];
    } catch (err) {
      console.warn('Chart generation failed, returning empty array:', err);
      return [];
    }
  }

  // Helper method to safely get tables
  private async getTablesSafely(data: any): Promise<any[]> {
    try {
      if (!data) {
        throw new Error('No data provided for tables');
      }
      const tables = await this.getTables(data);
      return tables;
    } catch (err) {
      console.warn('Table generation failed, returning empty array:', err);
      return [];
    }
  }
  // Helper for timeout
  private timeoutPromise(ms: number): Promise<null> {
    return new Promise((resolve) => setTimeout(() => resolve(null), ms));
  }

  private getInvestmentDetails(data: any): any {
    // Ensure investmentDetails exists and is an array
    const investmentDetails = data?.investmentDetails || [];
    const allocationByFundResult = data?.allocationByFundResult || [];

    // Create properly structured investment data with titles and values
    const brandPrimary = '#18467d';
    const investmentData = [
      {
        title: 'Investment (₹)',
        value: this.safeText(
          investmentDetails[0]?.value || investmentDetails[0] || '0'
        ),
        color: brandPrimary
      },
      {
        title: 'Current Value (₹)',
        value: this.safeText(
          investmentDetails[1]?.value || investmentDetails[1] || '0'
        ),
        color: brandPrimary
      },
      {
        title: 'Profit/Loss (₹)',
        value: this.safeText(
          investmentDetails[2]?.value || investmentDetails[2] || '0'
        ),
        color: brandPrimary
      },
      {
        title: 'XIRR (%)',
        value: this.safeText(
          this.formatNumber(
            investmentDetails[3]?.value || investmentDetails[3] || 0
          )
        ),
        color: brandPrimary
      },
      {
        title: 'Total Funds Invested In',
        value: `${Math.max(0, allocationByFundResult.length - 1)}`,
        color: brandPrimary
      }
    ];

    const row = investmentData.map((item: any, idx: number) => {
      const title = this.safeText(item?.title) || 'N/A';
      let value = this.safeText(this.formatNumber(Number(item?.value) || 0));

      // Handle percentage formatting for XIRR
      if (idx === 3 && value !== '0' && !value.includes('%')) {
        value = `${value}%`;
      }

      return {
        columns: [
          {
            text: title,
            color: '#1A1A1A',
            bold: false,
            fontSize: 9,
            fillColor: idx === 0 ? '#E6F3FF' : undefined // header bg color for first row
          },
          {
            text: value,
            color:
              idx === 2 || idx === 3
                ? String(value).includes('-')
                  ? 'red'
                  : '#00A63E'
                : '#1A1A1A',
            bold: true,
            fontSize: 8,
            fillColor: idx === 0 ? '#E6F3FF' : undefined // header bg color for first row
          }
        ],
        alignment: 'center',
        margin: [2, 8, 2, 8] // [left, top, right, bottom]
      };
    });

    // Flatten columns for each cell
    const formattedRow = row.map((cell) => ({
      text: this.safeText(cell.columns[0].text),
      color: cell.columns[0].color,
      bold: cell.columns[0].bold,
      fontSize: cell.columns[0].fontSize
    }));

    // Add value row
    const valueRow = row.map((cell) => ({
      text: this.safeText(cell.columns[1].text),
      color: cell.columns[1].color,
      bold: cell.columns[1].bold,
      fontSize: cell.columns[1].fontSize
    }));

    return [
      {
        table: {
          headerRows: 0,
          widths: Array(formattedRow.length).fill('*'),
          body: [formattedRow, valueRow]
        },
        layout: {
          hLineWidth: (i: number): number => {
            return i === 0 || i === 1 ? 0.5 : 0; // Only header borders
          },
          vLineWidth: (): number => 0, // Remove vertical lines
          hLineColor: (): string => '#D9D9D9',
          vLineColor: (): string => '#D9D9D9'
        },
        margin: [0, 5, 0, 15]
      }
    ];
  }

  /**
   * Generate chart section using base64 strings (no html2canvas dependency)
   * This is platform-independent and much faster
   */
  private getChartDataFromBase64(
    chartBase64_1: string,
    chartBase64_2: string,
    chartBase64_3: string
  ): any[] {
    const chartHeaders = {
      table: {
        headerRows: 0,
        widths: ['*', '*', '*'],
        body: [
          [
            {
              text: 'Asset Allocation',
              bold: true,
              alignment: 'center',
              fontSize: 9,
              margin: [8, 2, 8, 2] // smaller top/bottom margin
            },
            {
              text: 'Equity Mutual Fund Distribution',
              bold: true,
              alignment: 'center',
              fontSize: 9,
              margin: [8, 2, 8, 2] // smaller top/bottom margin
            },
            {
              text: 'Sector Exposure (Top 5)',
              bold: true,
              alignment: 'center',
              fontSize: 9,
              margin: [8, 2, 8, 2] // smaller top/bottom margin
            }
          ]
        ]
      },
      layout: {
        fillColor: (): string => '#F9FAFB',
        hLineWidth: (): number => 1,
        vLineWidth: (): number => 0, // Remove vertical lines
        hLineColor: (): string => '#E7E7E7',
        vLineColor: (): string => '#E7E7E7'
      },
      margin: [0, 0, 0, 0]
    };

    // Increase fit by 10%: 200x150 -> 220x165
    // Using fit instead of width/height preserves aspect ratio and image quality
    return [
      chartHeaders,
      {
        columns: [
          {
            image: this.ensureDataUrl(chartBase64_1),
            fit: [240, 185], // Size constraint while maintaining quality
            margin: [4, 2, 4, 2],
            width: '33.3%',
            alignment: 'center'
          },
          {
            image: this.ensureDataUrl(chartBase64_2),
            fit: [240, 185],
            margin: [4, 2, 4, 2],
            width: '33.3%',
            alignment: 'center'
          },
          {
            image: this.ensureDataUrl(chartBase64_3),
            fit: [240, 185],
            margin: [4, 2, 4, 2],
            width: '33.3%',
            alignment: 'center'
          }
        ],
        columnGap: 0
      }
    ];
  }

  private async getTables(data: any): Promise<any> {
    data.sectorWise = (data.sectorWise || [])
      .sort(
        (a: { value: string }, b: { value: string }) =>
          parseFloat(b.value) - parseFloat(a.value)
      )
      .splice(0, 5);

    return [
      {
        columns: [
          {
            width: '33.3%',
            stack: [
              {
                ...this.getDataGridContent(
                  data.assetAllocation,
                  REPORT.MF_DISTRIBUTION_COLUMN,
                  REPORT.PORTFOLIO_SUMMARY_REPORT,
                  ['*', '*', '*'],
                  true
                ),
                fontSize: 8,
                fit: [270, 160]
              }
            ]
          },
          {
            width: '33.3%',
            stack: [
              {
                ...this.getDataGridContent(
                  data.mutualFundEquiltyDistribution,
                  REPORT.MF_DISTRIBUTION_COLUMN,
                  REPORT.PORTFOLIO_SUMMARY_REPORT,
                  ['*', '*', '*'],
                  true
                ),
                fontSize: 8,
                fit: [270, 160]
              }
            ]
          },
          {
            width: '33.33%',
            stack: [
              {
                ...this.getDataGridContent(
                  data.sectorWise,
                  REPORT.SECTOR_COLUMN,
                  REPORT.PORTFOLIO_SUMMARY_REPORT,
                  ['*', '*'],
                  true
                ),
                fontSize: 8,
                fit: [270, 160]
              }
            ]
          }
        ],
        columnGap: 10,
        margin: [0, 5, 0, 5]
      }
    ];
  }

  private getAllocationPercentage(data: any): any {
    return [
      {
        text: REPORT.ALLOCATION_DIS,
        style: 'tableheading',
        margin: [0, 15, 0, 5],
        pageBreak: 'before' // Always start on next page
      },
      {
        ...this.buildSortedAllocationTable(
          data.allocationByFundResult,
          REPORT.ALLOCATION_FUND_COLUMN,
          REPORT.PORTFOLIO_SUMMARY_REPORT
        ),
        fontSize: 8
      },
      { text: '', margin: [0, 10] }
    ];
  }

  private getTopFiveFunds(data: any): any {
    return [
      {
        columns: [
          {
            stack: [
              {
                text: REPORT.DISPLAY_REPORT[4],
                style: 'tableheading',
                margin: [0, 5, 0, 5]
              },
              {
                ...this.getDataGridContent(
                  data.topFiveDebtFundsResult,
                  REPORT.EQUITY_ALLOCATION_COLUMN,
                  REPORT.PORTFOLIO_SUMMARY_REPORT
                ),
                fontSize: 8
              }
            ],
            width: '50%'
          },
          {
            stack: [
              // { text: '', margin: [0, 10] },
              {
                text: REPORT.DISPLAY_REPORT[5],
                style: 'tableheading',
                margin: [0, 5, 0, 5]
              },
              {
                ...this.getDataGridContent(
                  data.topFiveEquityFundsResult,
                  REPORT.DEBT_ALLOCATION_COLUMN,
                  REPORT.PORTFOLIO_SUMMARY_REPORT
                ),
                fontSize: 8
              }
            ],
            width: '50%'
          }
        ],
        columnGap: 10
      }
    ];
  }

  /**
   * function to generate table header
   * @method getColumnHeaders
   * @memberof reportService
   */

  private getColumnHeaders(header: string | string[]): any[] {
    return Array.isArray(header)
      ? header.map((h) => ({
          text: h,
          fillColor: '#E6F3FF',
          bold: true
        }))
      : [{ text: header, fillColor: '#E6F3FF', bold: true }];
  }

  /**
   * function to generate table data
   * @method getDataGridContent
   * @memberof reportService
   */

  private getDataGridContent(
    data: any[],
    column: string[],
    reportName: string,
    widths?: string[],
    showLegend: boolean = false
  ): any {
    const body: any[][] = [this.getColumnHeaders(column)];
    const colorPalette = [
      '#36A3EB',
      '#FE6383',
      '#FF9F40',
      '#FFCC55',
      '#4CC0BF'
    ];
    const reportMapping: Record<string, (item: any, count: number) => void> = {
      [REPORT.PORTFOLIO_SUMMARY_REPORT]: (item) => {
        if (column === REPORT.INVESTMENT_SINCE) {
          body?.push([this.safeText(item?.title), this.safeText(item?.value)]);
        } else if (
          column === REPORT.MF_DISTRIBUTION_COLUMN ||
          column === REPORT.MF_EQUITY_COLUMN
        ) {
          body?.push([
            this.safeText(item?.subCategory),
            this.safeText(this.formatNumber(Number(item?.currentValue))),
            this.safeText(this.formatNumber(Number(item?.allocationValue || 0)))
          ]);
        } else if (column === REPORT.SECTOR_COLUMN) {
          body?.push([
            this.safeText(item?.sector),
            this.safeText(this.formatNumber(Number(item?.value || 0)))
          ]);
        } else if (
          column === REPORT.DEBT_ALLOCATION_COLUMN ||
          column === REPORT.EQUITY_ALLOCATION_COLUMN
        ) {
          body?.push([
            this.safeText(item?.schemeDisplayName),
            this.safeText(this.formatNumber(Number(item?.currentValue))),
            this.safeText(
              this.formatNumber(Number(item?.allocationPercentage || 0))
            )
          ]);
        } else {
          //NOT in Use for time being
          body?.push([
            this.safeText(item?.folio),
            this.safeText(item?.schemeDisplayName),
            this.safeText(this.formatNumber(Number(item?.purchaseValue))),
            this.safeText(this.formatNumber(Number(item?.currentValue))),
            this.safeText(
              this.formatNumber(Number(item?.allocationPercentage || 0))
            ),
            this.safeText(this.formatNumber(Number(item?.unitsHeld || 0))),
            'TBD',
            {
              text: this.safeText(
                this.formatNumber(Number(item?.absoluteReturn))
              ),
              color:
                (item?.absoluteReturn || 0) > 0
                  ? 'green'
                  : (item?.absoluteReturn || 0) < 0
                    ? 'red'
                    : 'black'
            },
            this.safeText(this.formatNumber(item?.xirr))
          ]);
        }
      },

      [REPORT.PORT_DETAIL_REPORT]: (item) => {
        body.push([
          this.safeText(
            item?.date
              ? dayjs(item.date).isValid()
                ? dayjs(item.date).format('DD/MM/YYYY')
                : item.date
              : ''
          ),
          this.safeText(this.formatNumber(Number(item?.purchaseValue || 0))),
          this.safeText(this.formatNumber(Number(item?.purchaseNav || 0))),
          this.safeText(item?.transactionType),
          this.safeText(this.formatNumber(Number(item?.units || 0))),
          this.safeText(this.formatNumber(Number(item?.currentValue || 0))),
          this.safeText(item?.days),
          this.safeText(this.formatNumber(Number(item?.gain || 0))),
          this.safeText(
            this.formatNumber(Number(item?.transactionAbsoluteReturn || 0))
          )
        ]);
      },
      [REPORT.CAPITAL_GAIN_DETAIL]: (item) => {
        // Check if this is a total row
        if (item?.isTotalRow) {
          body.push([
            { text: '', bold: true },
            { text: '', bold: true },
            { text: 'Total:', bold: true, fontSize: 8 },
            {
              text: this.formatNumber(Number(item?.unitsSold || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.redemptionValue || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.purchaseValue || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.acquisitionValue || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.shortTermCapitalGain || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.longTermCapitalGain || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.load || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.stampDuty || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.stt || 0)),
              bold: true,
              fontSize: 8
            },
            {
              text: this.formatNumber(Number(item?.tds || 0)),
              bold: true,
              fontSize: 8
            }
          ]);
        } else {
          body.push([
            this.safeText(item?.folioNumber || 'N/A'),
            this.safeText(
              item?.purchaseDate
                ? dayjs(item.purchaseDate).format('DD/MM/YYYY')
                : ''
            ),
            this.safeText(
              item?.redemptionDate
                ? dayjs(item.redemptionDate).format('DD/MM/YYYY')
                : ''
            ),
            this.safeText(this.formatNumber(Number(item?.unitsSold || 0))),
            this.safeText(
              this.formatNumber(Number(item?.redemptionValue || 0))
            ),
            this.safeText(this.formatNumber(Number(item?.purchaseValue || 0))),
            this.safeText(
              this.formatNumber(Number(item?.acquisitionValue || 0))
            ),
            this.safeText(
              this.formatNumber(Number(item?.shortTermCapitalGain || 0))
            ),
            this.safeText(
              this.formatNumber(Number(item?.longTermCapitalGain || 0))
            ),
            this.safeText(this.formatNumber(Number(item?.load || 0))),
            this.safeText(this.formatNumber(Number(item?.stampDuty || 0))),
            this.safeText(this.formatNumber(Number(item?.stt || 0))),
            this.safeText(this.formatNumber(Number(item?.tds || 0)))
          ]);
        }
      },
      [REPORT.CAPITAL_SUMMARY_REPORT]: (item, count) => {
        if (!item) {
          return;
        }

        // Check if this is an asset type header row
        if (item.isAssetTypeHeader) {
          body.push([
            {
              text: item.schemeName,
              colSpan: column.length,
              color: '#800000',
              bold: true,
              fillColor: 'white',
              fontSize: 8
            },
            ...Array(column.length - 1).fill({ text: '' })
          ]);
          return;
        }

        // Check if this is a category total row
        if (item.isCategoryTotal) {
          const formatValue = (value: any) => {
            const num = Number(value || 0);
            return isNaN(num) ? '0.00' : this.formatNumber(num);
          };

          body.push([
            { text: '', bold: true, fillColor: '#E6F3FF' },
            { text: '', bold: true, fillColor: '#E6F3FF' },
            { text: 'Total:', bold: true, fontSize: 8, fillColor: '#E6F3FF' },
            {
              text: formatValue(item.totalUnitsSold),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.redemptionValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.purchaseValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.acquisitionValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.shortTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.longTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalLoad),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStampDuty),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStt),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF',
              fontWeight: 'bold'
            },
            {
              text: formatValue(item.totalTds),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            }
          ]);
          return;
        }

        // Format numbers safely with proper null checks
        const formatValue = (value: any) => {
          const num = Number(value || 0);
          return isNaN(num) ? '0.00' : this.formatNumber(num);
        };

        body.push([
          this.safeText(item?.folioNumber || 'N/A'),
          this.safeText(item?.schemeDisplayName || item?.schemeName || 'N/A'),
          this.safeText(item?.isin || 'N/A'),
          this.safeText(this.formatNumber(Number(item?.totalUnitsSold || 0))),
          formatValue(item?.redemptionValueTotal),
          formatValue(item?.purchaseValueTotal),
          formatValue(item?.acquisitionValueTotal),
          formatValue(item?.shortTermCapitalGainTotal),
          formatValue(item?.longTermCapitalGainTotal),
          formatValue(item?.totalLoad),
          formatValue(item?.totalStampDuty),
          formatValue(item?.totalStt),
          formatValue(item?.totalTds)
        ]);
      },
      [REPORT.CAPITAL_GAIN_UNREAL_DETAIL]: (item) => {
        // Check if this is a category total row
        if (item?.isCategoryTotal) {
          const formatValue = (value: any) => {
            const num = Number(value || 0);
            return isNaN(num) ? '0.00' : this.formatNumber(num);
          };

          body.push([
            { text: '', bold: true, fillColor: '#E6F3FF' },
            { text: 'Total:', bold: true, fontSize: 8, fillColor: '#E6F3FF' },
            {
              text: formatValue(item.purchaseValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.acquisitionValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.shortTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.longTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalLoad),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStampDuty),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStt),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalTds),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            }
          ]);
        } else {
          body.push([
            this.safeText(item?.folioNumber || 'N/A'),
            // this.safeText(item?.schemeDisplayName || item?.schemeName || 'N/A'),
            this.safeText(
              item?.purchaseDate
                ? dayjs(item.purchaseDate).format('DD/MM/YYYY')
                : ''
            ),
            this.safeText(this.formatNumber(Number(item?.purchaseValue || 0))),
            this.safeText(
              this.formatNumber(Number(item?.acquisitionValue || 0))
            ),
            this.safeText(
              this.formatNumber(Number(item?.shortTermCapitalGain || 0))
            ),
            this.safeText(
              this.formatNumber(Number(item?.longTermCapitalGain || 0))
            ),
            this.safeText(this.formatNumber(Number(item?.load || 0))),
            this.safeText(this.formatNumber(Number(item?.stampDuty || 0))),
            this.safeText(this.formatNumber(Number(item?.stt || 0))),
            this.safeText(this.formatNumber(Number(item?.tds || 0)))
          ]);
        }
      },

      [REPORT.CAPITAL_GAIN_UNREAL_SUMMARY_REPORT]: (item, count) => {
        if (!item) {
          return;
        }

        // Check if this is an asset type header row
        if (item.isAssetTypeHeader) {
          body.push([
            {
              text: item.schemeName,
              colSpan: column.length,
              color: '#800000',
              bold: true,
              fillColor: 'white',
              fontSize: 8
            },
            ...Array(column.length - 1).fill({ text: '' })
          ]);
          return;
        }

        // Check if this is a category total row
        if (item.isCategoryTotal) {
          const formatValue = (value: any) => {
            const num = Number(value || 0);
            return isNaN(num) ? '0.00' : this.formatNumber(num);
          };

          body.push([
            { text: '', bold: true, fillColor: '#E6F3FF' },
            { text: '', bold: true, fillColor: '#E6F3FF' },
            { text: 'Total:', bold: true, fontSize: 8, fillColor: '#E6F3FF' },
            {
              text: formatValue(item.purchaseValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.acquisitionValueTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.shortTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.longTermCapitalGainTotal),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalLoad),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStampDuty),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalStt),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            },
            {
              text: formatValue(item.totalTds),
              bold: true,
              fontSize: 8,
              fillColor: '#E6F3FF'
            }
          ]);
          return;
        }

        // Format numbers safely with proper null checks
        const formatValue = (value: any) => {
          const num = Number(value || 0);
          return isNaN(num) ? '0.00' : this.formatNumber(num);
        };

        body.push([
          this.safeText(item?.folioNumber || 'N/A'),
          this.safeText(item?.schemeDisplayName || item?.schemeName || 'N/A'),
          this.safeText(item?.isin || 'N/A'),
          formatValue(item?.purchaseValueTotal),
          formatValue(item?.acquisitionValueTotal),
          formatValue(item?.shortTermCapitalGainTotal),
          formatValue(item?.longTermCapitalGainTotal),
          formatValue(item?.totalLoad),
          formatValue(item?.totalStampDuty),
          formatValue(item?.totalStt),
          formatValue(item?.totalTds)
        ]);
      },
      [REPORT.TRANSACTION_SUMMARY_REPORT]: (item, count) => {
        if (!item) {
          return;
        }

        // Format date as DD/MM/YYYY
        const formattedDate = item?.date
          ? dayjs(item.date).format('DD/MM/YYYY')
          : 'N/A';

        body.push([
          this.safeText(
            item?.schemeDisplayName || item?.schemeDetails || 'N/A'
          ),
          this.safeText(item?.orderId || 'N/A'),
          this.safeText(formattedDate),
          this.safeText(item?.transactionType || 'N/A'),
          this.safeText(this.formatNumber(Number(item?.amount || 0)))
        ]);
      }
    };

    let count = 1;
    // Safely process data with null checks
    const safeData = Array.isArray(data) ? data : [];
    safeData
      .filter((item) => item != null && item !== undefined)
      .forEach((item) => {
        try {
          const handler = reportMapping[reportName];
          if (handler) {
            handler(item, count++);
          }
        } catch (error) {
          console.warn('Error processing table row:', error, item);
          // Skip this item but continue processing
        }
      });
    if (column !== REPORT.SECTOR_COLUMN) {
      const lastIndex = body.length - 1;
      body[lastIndex] = body[lastIndex].map((cell) =>
        typeof cell === 'object' && cell !== null
          ? { ...cell, bold: true }
          : { text: cell, bold: true }
      );
    }

    const tableBody: any[] = body.map((row: any[], rowIndex: number): any[] => {
      // Ensure row has the correct number of columns
      const normalizedRow = [...row];
      while (normalizedRow.length < column.length) {
        normalizedRow.push('');
      }

      return normalizedRow.map((cell: any, colIndex: number): any => {
        // Ensure cell is never undefined
        const safeCell = cell !== undefined && cell !== null ? cell : '';

        if (rowIndex === 0) {
          // Header row - cell is already an object with text, fillColor, bold properties
          return typeof safeCell === 'object' && safeCell !== null
            ? { ...safeCell, alignment: 'center' }
            : { text: String(safeCell), alignment: 'center' };
        }

        if (
          colIndex === 0 &&
          rowIndex > 0 &&
          body[rowIndex][0]?.text !== 'Total' &&
          showLegend
        ) {
          // use (rowIndex - 1) because rowIndex=0 is header
          const color = colorPalette[rowIndex - 1];
          const cellText =
            typeof safeCell === 'object' && safeCell !== null && safeCell.text
              ? safeCell.text
              : String(safeCell);

          // Extract style properties if cell is an object
          const cellProps =
            typeof safeCell === 'object' && safeCell !== null
              ? {
                  bold: safeCell.bold,
                  fillColor: safeCell.fillColor,
                  fontSize: safeCell.fontSize
                }
              : {};

          return {
            columns: [
              {
                canvas: [
                  {
                    type: 'ellipse',
                    x: 6,
                    y: 6,
                    color,
                    r1: 3,
                    r2: 3,
                    lineColor: color
                  }
                ],
                width: 12,
                margin: [0, 0, 4, 0]
              },
              {
                text: cellText,
                alignment: 'left',
                ...cellProps
              }
            ],
            alignment: 'left',
            ...cellProps
          };
        } else {
          // Extract text from object cells
          const cellText =
            typeof safeCell === 'object' && safeCell !== null
              ? safeCell.text !== undefined
                ? String(safeCell.text)
                : String(safeCell)
              : String(safeCell);
          const cellColor =
            typeof safeCell === 'object' && safeCell !== null && safeCell.color
              ? safeCell.color
              : undefined;

          // Determine alignment: text columns (scheme, fund, folio, isin, details) should be left-aligned
          // Reference header from body[0] instead of tableBody[0] to avoid initialization issue
          const headerCell: any = body[0]?.[colIndex] || '';
          const headerText: string =
            (typeof headerCell === 'object'
              ? headerCell?.text
              : String(headerCell)) || '';
          const isTextColumn: boolean =
            headerText.toLowerCase().includes('scheme') ||
            headerText.toLowerCase().includes('fund') ||
            headerText.toLowerCase().includes('folio') ||
            headerText.toLowerCase().includes('isin') ||
            headerText.toLowerCase().includes('details') ||
            headerText.toLowerCase().includes('type') ||
            headerText.toLowerCase().includes('period');

          // Preserve style properties (bold, fillColor, fontSize, colSpan, etc.)
          if (typeof safeCell === 'object' && safeCell !== null) {
            const { text, color, ...rest } = safeCell as any;
            return {
              text: cellText,
              alignment: isTextColumn ? 'left' : 'right',
              color: color || cellColor,
              ...rest
            };
          }

          return {
            text: cellText,
            alignment: isTextColumn ? 'left' : 'right',
            color: cellColor
          };
        }
      });
    });

    // Calculate widths: if a column named 'fund' (case-insensitive) exists, make it 2x width, rest equal
    // For capital gain reports, make scheme name column wider
    let widthsArr: (string | number)[] = widths || [];
    if (!widthsArr.length && tableBody[0]?.length) {
      const fundIdx = tableBody[0].findIndex((cell: any) =>
        (typeof cell === 'object'
          ? (cell.text || '').toLowerCase()
          : String(cell).toLowerCase()
        ).includes('fund')
      );
      const schemeIdx = tableBody[0].findIndex((cell: any) =>
        (typeof cell === 'object'
          ? (cell.text || '').toLowerCase()
          : String(cell).toLowerCase()
        ).includes('scheme')
      );
      const isinIdx = tableBody[0].findIndex((cell: any) =>
        (typeof cell === 'object'
          ? (cell.text || '').toLowerCase()
          : String(cell).toLowerCase()
        ).includes('isin')
      );
      const folioIdx = tableBody[0].findIndex((cell: any) =>
        (typeof cell === 'object'
          ? (cell.text || '').toLowerCase()
          : String(cell).toLowerCase()
        ).includes('folio')
      );
      const colCount = tableBody[0].length;
      const base = 1;
      widthsArr = Array(colCount).fill(base);
      if (fundIdx !== -1) {
        widthsArr[fundIdx] = base * 3.25;
      }
      // For capital gain summary and portfolio detail reports, make scheme name column 3x wider, ISIN and Folio 1.5x
      if (
        reportName === REPORT.CAPITAL_SUMMARY_REPORT ||
        reportName === REPORT.CAPITAL_GAIN_UNREAL_SUMMARY_REPORT ||
        reportName === REPORT.PORT_DETAIL_REPORT
      ) {
        if (schemeIdx !== -1) {
          widthsArr[schemeIdx] = base * 2.8; // Scheme name: 2.8x wider
        }
        if (isinIdx !== -1) {
          widthsArr[isinIdx] = base * 1.2; // ISIN: 1.2x wider
        }
        if (folioIdx !== -1) {
          widthsArr[folioIdx] = base * 1.2; // Folio: 1.2x wider
        }
      }
      const total = widthsArr.reduce((a, b) => Number(a) + Number(b), 0);
      widthsArr = widthsArr.map((w) => `${(Number(w) / Number(total)) * 100}%`);
    }

    return {
      table: {
        headerRows: 1,
        widths: widthsArr,
        body: tableBody
      },
      layout: {
        fillColor: (
          rowIndex: number,
          _node: any,
          _columnIndex: number
        ): string | null => {
          if (rowIndex === 0) {
            return '#F9FAFB';
          } // header row

          // Check if this is a total row (bold text in the row)
          const currentRow = tableBody[rowIndex];
          if (currentRow && Array.isArray(currentRow)) {
            const isTotalRow = currentRow.some(
              (cell: any) =>
                (typeof cell === 'object' && cell?.bold === true) ||
                (typeof cell === 'object' && cell?.text === 'Total:')
            );
            if (isTotalRow) {
              return '#E6F3FF'; // Light blue background for total rows
            }
          }

          return rowIndex % 2 === 0 ? '#f3f4f6' : '#FFFFFF'; // even/odd rows using gray-100 (#f3f4f6)
        },
        hLineWidth: (i: number): number => {
          return i === 0 || i === 1 ? 0.5 : 0; // Only header borders
        },
        vLineWidth: () => 0, // Remove vertical lines
        hLineColor: () => '#D9D9D9',
        vLineColor: () => '#D9D9D9',
        paddingLeft: () => 2, // Reduce left padding for tight layout
        paddingRight: () => 2, // Reduce right padding for tight layout
        paddingTop: () => 1.5, // Reduce top padding for tight layout
        paddingBottom: () => 1.5 // Reduce bottom padding for tight layout
      },
      margin: [0, 0, 0, 5],
      fontSize: 6
    };
  }
  /**
     * 
        Function to create a separate table for Allocation By Fund
     */

  private buildSortedAllocationTable(
    data: any[],
    column: string[],
    reportName: string
  ): any {
    const grouped: Record<string, any[]> = {};

    data.forEach((item) => {
      if (!item.assetType || !item.assetCategory) {
        // Treat this as Grand Total
        const category = 'Grand Total:';
        if (!grouped[category]) {
          grouped[category] = [];
        }
        grouped[category].push(item);
        return;
      }

      const category = `${item.assetType}: ${item.assetCategory}`;
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(item);
    });

    const body: any[] = [];
    const rowMeta: number[] = []; // stores row index within category

    const categories = Object.keys(grouped);

    categories.forEach((category) => {
      // Group header row - create unique empty objects for colSpan cells
      const headerRow: any[] = [
        {
          text: category,
          colSpan: column.length,
          color: '#800000',
          bold: true,
          fillColor: 'white',
          fontSize: 8
        }
      ];
      // Add unique empty objects for remaining cells (required by pdfmake)
      for (let i = 1; i < column.length; i++) {
        headerRow.push({});
      }
      body.push(headerRow);
      rowMeta.push(-1); // mark as group label

      let localRow = 0;

      grouped[category].forEach((item) => {
        body.push([
          item.folio,
          item.schemeDisplayName,
          this.formatNumber(Number(item.purchaseValue)),
          this.formatNumber(Number(item.currentValue)),
          this.formatNumber(Number(item.allocationPercentage)),
          this.formatNumber(Number(item.unitsHeld)),
          Number(item.weightAvgHoldingDays)
            ? Number(item.weightAvgHoldingDays)
            : '-',
          {
            text: this.formatNumber(Number(item.absoluteReturn)),
            color:
              item.absoluteReturn > 0
                ? 'green'
                : item.absoluteReturn < 0
                  ? 'red'
                  : 'black'
          },
          this.formatNumber(item.xirr)
        ]);
        rowMeta.push(localRow++); // store row index within group
      });
    });

    const lastIndex = body.length - 1;
    body[lastIndex] = body[lastIndex].map((cell: any) =>
      typeof cell === 'object' && cell !== null
        ? { ...cell, bold: true }
        : { text: cell, bold: true }
    );

    const tableBody = [
      column.map((h) => ({
        text: String(h),
        bold: true,
        fillColor: '#E6F3FF',
        alignment: 'center'
      })), // header color
      ...body.map((row: any[], rowIndex: number) => {
        // Ensure row has correct number of cells
        const normalizedRow = [...row];
        while (normalizedRow.length < column.length) {
          normalizedRow.push({});
        }

        return normalizedRow.map((cell, colIndex: number) => {
          const base =
            typeof cell === 'object' && cell !== null && 'text' in cell
              ? { ...cell }
              : {
                  text: String(cell !== undefined && cell !== null ? cell : '')
                };

          return {
            ...base,
            text: base.text !== undefined ? String(base.text) : '',
            alignment:
              rowMeta[rowIndex] === -1 || colIndex === 1 ? 'left' : 'right',
            bold: rowIndex === body.length - 1 ? true : base.bold || false
          };
        });
      })
    ];

    // Calculate widths: fund name column is 3.5x, purchase/current val columns are 1.5x, rest are equal
    const fundNameIndex = column.findIndex(
      (col) =>
        col.toLowerCase().includes('fund name') ||
        col.toLowerCase().includes('scheme name')
    );
    const purchaseValIndex = column.findIndex((col) =>
      col.toLowerCase().includes('purchase val')
    );
    const currentValIndex = column.findIndex((col) =>
      col.toLowerCase().includes('current val')
    );
    const folioIndex = column.findIndex((col) =>
      col.toLowerCase().includes('folio number')
    );
    const totalCols = column.length;
    const baseWidth = 1;
    const widths = Array(totalCols).fill(baseWidth);
    if (fundNameIndex !== -1) {
      widths[fundNameIndex] = baseWidth * 3.25;
    }
    if (purchaseValIndex !== -1) {
      widths[purchaseValIndex] = baseWidth * 1.3;
    }
    if (folioIndex !== -1) {
      widths[folioIndex] = baseWidth * 1.2;
    }
    if (currentValIndex !== -1) {
      widths[currentValIndex] = baseWidth * 1.3;
    }
    // Convert to percentage for pdfMake
    const totalWidth = widths.reduce((a, b) => a + b, 0);
    const widthsPercent = widths.map((w) => `${(w / totalWidth) * 100}%`);

    return {
      table: {
        headerRows: 1,
        body: tableBody,
        widths: widthsPercent
      },
      layout: {
        fillColor: (rowIndex: number): string | null => {
          if (rowIndex === 0) {
            return '#F9FAFB';
          } // header
          const localIndex = rowMeta[rowIndex - 1];
          return localIndex >= 0 && localIndex % 2 === 0 ? '#f3f4f6' : null; // grey rows using gray-100 (#f3f4f6)
        },
        hLineWidth: (i: number): number => {
          return i === 0 || i === 1 ? 0.5 : 0; // Only header borders
        },
        vLineWidth: (): number => 0, // Remove vertical lines
        hLineColor: (): string => '#E7E7E7', // border color
        vLineColor: (): string => '#E7E7E7', // border color
        paddingLeft: () => 2, // Reduce left padding for tight layout
        paddingRight: () => 2, // Reduce right padding for tight layout
        paddingTop: () => 1.5, // Reduce top padding for tight layout
        paddingBottom: () => 1.5 // Reduce bottom padding for tight layout
      },
      fontSize: 6
    };
  }

  /**
   * function to generate table excel, added condition to check for 31 characters in a sheet Name
   * @method generateExcel
   * @memberof reportService
   */
  generateExcel(reportName: string, ...elements: (HTMLElement | null)[]) {
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    elements.forEach((element, index) => {
      if (element) {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

        const rawSheetName =
          REPORT.DISPLAY_REPORT[index] || `Sheet${index + 1}`;
        let sheetName = rawSheetName;
        if (sheetName.length > 31) {
          sheetName = rawSheetName.slice(0, 28) + '...'; // max 31 chars
        }
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }
    });

    // const sanitizedReportName = reportName.replace(/\s+/g, '_');
    const sanitizedClientName = this.clientandRMDetails?.clientName.replace(
      /\s+/g,
      '_'
    );
    const todayDate = dayjs().format('YYYYMMDD');

    XLSX.writeFile(
      wb,
      `${reportName}_${sanitizedClientName}_${todayDate}.xlsx`
    );
  }

  showDatesInFormat(startDate: string, endDate: string): string {
    if (!startDate) {
      return dayjs(endDate).format('DD/MM/YY');
    }
    if (startDate && endDate) {
      return (
        dayjs(startDate).format('DD/MM/YY') +
        ' to ' +
        dayjs(endDate).format('DD/MM/YY')
      );
    }
    return '';
  }
  /**
   * function to generate pdf dynamic data for all PDFs
   * @method dynamiContent
   * @memberof reportService
   */

  dynamiContent(
    data: any,
    documentDefinition: any,
    column: any,
    reportName: string
  ) {
    const isTransactionOrCapitalSummary =
      reportName === REPORT.TRANSACTION_SUMMARY_REPORT ||
      reportName === REPORT.CAPITAL_SUMMARY_REPORT ||
      reportName === REPORT.CAPITAL_GAIN_UNREAL_SUMMARY_REPORT;

    if (isTransactionOrCapitalSummary) {
      const tableContent = this.getDataGridContent(data, column, reportName);
      documentDefinition.content.push({
        ...tableContent,
        fontSize: 8,
        margin: [0, 0, 0, 15]
      });
    } else {
      const isProDetailOrCapitalDetail =
        reportName === REPORT.PORT_DETAIL_REPORT ||
        reportName === REPORT.CAPITAL_GAIN_DETAIL ||
        reportName === REPORT.CAPITAL_GAIN_UNREAL_DETAIL;
      if (isProDetailOrCapitalDetail) {
        data?.forEach((item: any) => {
          // Add financial instrument header before very first item
          if (item.isFirstItem && item.financialInstrumentHeader) {
            documentDefinition.content.push({
              text: item.financialInstrumentHeader,
              style: 'tableheading',
              color: '#215099',
              bold: true,
              fontSize: 11,
              margin: [0, 5, 0, 3]
            });
          }

          // Add asset type header before first item in each group
          if (item.isFirstInGroup && item.assetTypeHeader) {
            documentDefinition.content.push({
              text: item.assetTypeHeader,
              style: 'tableheading',
              color: '#800000',
              margin: [0, 5, 0, 3]
            });
          }

          const itemName =
            item.schemeDisplayName || item.fundName || item.schemeName;
          const isinNumber = item.isin ? ` (${item.isin})` : '';
          const itemNameWithISIN = `${itemName}${isinNumber}`;
          documentDefinition.content.push({
            text: itemNameWithISIN,
            style: 'tableheading'
          });

          // Prepare transaction data with total row for capital gain detail report
          let transactionData =
            reportName === REPORT.PORT_DETAIL_REPORT
              ? item.fundTransactions
              : item.txnsList;

          // Add total row to transaction data for Capital Gain Detail Report
          if (
            reportName === REPORT.CAPITAL_GAIN_DETAIL &&
            item.txnsList &&
            item.txnsList.length > 0
          ) {
            transactionData = [
              ...item.txnsList,
              {
                folioNumber: null,
                purchaseDate: null,
                redemptionDate: null,
                unitsSold: item.totalUnitsSold,
                redemptionValue: item.redemptionValueTotal,
                purchaseValue: item.purchaseValueTotal,
                acquisitionValue: item.acquisitionValueTotal,
                shortTermCapitalGain: item.shortTermCapitalGainTotal,
                longTermCapitalGain: item.longTermCapitalGainTotal,
                load: item.totalLoad,
                stampDuty: item.totalStampDuty,
                stt: item.totalStt,
                tds: item.totalTds,
                isTotalRow: true
              }
            ];
          }

          // Add total row to transaction data for Capital Gain Unrealized Detail Report
          if (
            reportName === REPORT.CAPITAL_GAIN_UNREAL_DETAIL &&
            item.txnsList &&
            item.txnsList.length > 0
          ) {
            transactionData = [
              ...item.txnsList,
              {
                folioNumber: null,
                purchaseDate: null,
                purchaseValueTotal: item.purchaseValueTotal,
                acquisitionValueTotal: item.acquisitionValueTotal,
                shortTermCapitalGainTotal: item.shortTermCapitalGainTotal,
                longTermCapitalGainTotal: item.longTermCapitalGainTotal,
                totalLoad: item.totalLoad,
                totalStampDuty: item.totalStampDuty,
                totalStt: item.totalStt,
                totalTds: item.totalTds,
                isCategoryTotal: true
              }
            ];
          }

          const tableContent = this.getDataGridContent(
            transactionData,
            column,
            reportName
          );
          documentDefinition.content.push({
            ...tableContent,
            fontSize: 8,
            margin: [0, 0, 0, 8]
          });
        });
      } else {
        const addReportSection = (
          text: string,
          dataContent: any,
          column: any,
          margin: number[],
          absolutePosition?: { x: number; y: number }
        ) => {
          documentDefinition.content.push({
            text,
            style: 'tableheading',
            margin: text === REPORT.DISPLAY_REPORT[2] ? [0, 45, 0, 15] : null,
            absolutePosition: absolutePosition ?? null
          });
          const tableContent = this.getDataGridContent(
            dataContent,
            column,
            reportName
          );
          documentDefinition.content.push({
            ...tableContent,
            fontSize: 9,
            margin: margin,
            absolutePosition: absolutePosition ? { x: 300, y: 55 } : null
          });
        };

        addReportSection(
          REPORT.INVEST_SINCE,
          data.investmentDetails,
          REPORT.INVESTMENT_SINCE,
          [0, 0, 0, 15]
        );
        addReportSection(
          REPORT.DISPLAY_REPORT[0],
          data.assetAllocation,
          REPORT.MF_DISTRIBUTION_COLUMN,
          [0, 0, 0, 15]
        );
        addReportSection(
          REPORT.DISPLAY_REPORT[1],
          data.mutualFundEquiltyDistribution,
          REPORT.MF_EQUITY_COLUMN,
          [0, 0, 0, 15],
          { x: 300, y: 40 }
        );
        addReportSection(
          REPORT.DISPLAY_REPORT[2],
          data.allocationByFundResult,
          column,
          [0, 0, 0, 15]
        );
        addReportSection(
          REPORT.DISPLAY_REPORT[3],
          data.topTenDebtFundsResult,
          REPORT.EQUITY_ALLOCATION_COLUMN,
          [0, 0, 0, 15]
        );
        addReportSection(
          REPORT.DISPLAY_REPORT[4],
          data.topTenEquityFundsResult,
          REPORT.DEBT_ALLOCATION_COLUMN,
          [0, 0, 0, 15]
        );
      }
    }
  }

  /**
   * Load pdfMake library and fonts dynamically
   * Handles ES6 module default exports and font configuration
   */
  private async loadPdfMake(): Promise<any> {
    try {
      const pdfMakeModule = (await import('pdfmake/build/pdfmake')) as any;
      const pdfMake = pdfMakeModule.default || pdfMakeModule;

      // Load fonts
      try {
        const pdfFontsModule = await import('pdfmake/build/vfs_fonts');
        const pdfFonts = (pdfFontsModule as any).default || pdfFontsModule;

        if (pdfFonts?.pdfMake?.vfs) {
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        } else if (pdfFonts?.vfs) {
          pdfMake.vfs = pdfFonts.vfs;
        }
      } catch (fontError) {
        this.logger.error(
          'Failed to load pdfMake fonts',
          'ReportsModuleService.loadPdfMake',
          fontError
        );
      }

      return pdfMake;
    } catch (error) {
      this.logger.error(
        'Failed to load pdfMake',
        'ReportsModuleService.loadPdfMake',
        error
      );
      throw error;
    }
  }

  /**
   * Get safe font styles with fallback to default fonts
   */
  private getSafeStyles(): any {
    return {
      header: { fontSize: 8, bold: false },
      reportTitle: {
        fontSize: 8,
        bold: true,
        color: '#01529E'
      },
      date: {
        color: '#4D4D4D',
        fontSize: 8,
        bold: true
      },
      content: { fontSize: 8, color: '#1A1A1A' },
      Value: { fontSize: 8, color: '#1A1A1A' },
      disclaimer: {
        fontSize: 8,
        color: '#B3B3B3',
        margin: [0, 20, 0, 0]
      },
      tableStyle: {
        fontSize: 8,
        color: '#333333',
        margin: [0, 5, 0, 5],
        wordWrap: 'normal'
      },
      tableheading: {
        fontSize: 10,
        bold: true,
        color: '#1A1A1A',
        margin: [0, 5]
      },
      cardBox: {
        margin: [0, 5, 0, 5],
        alignment: 'center'
      },
      cardTitle: {
        bold: true,
        fontSize: 10,
        color: '#1A1A1A',
        margin: [0, 2, 0, 2]
      },
      cardValue: {
        fontSize: 8,
        color: '#4d4d4d'
      }
    };
  }

  /**
   * Safely convert any value to string for PDF text
   * Handles null, undefined, numbers, and objects
   */
  private safeText(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    if (typeof value === 'boolean') {
      return value.toString();
    }
    // For objects or other types, convert to string safely
    try {
      return String(value);
    } catch (error) {
      return '';
    }
  }

  /**
   * Format number to always show 2 decimal places
   * Examples: 100 -> 100.00, 12228.5 -> 12228.50, 100.12 -> 100.12
   */
  private formatNumber(value: number): string {
    // const rounded = Math.round(value * 100) / 100;
    // return rounded.toFixed(2);
    return this.numberFormattingService.formatNumber(value);
  }
}
